import { UserSelectLocale } from "..";

const locale: UserSelectLocale = {
  placeholder: '点击搜索',
  title: "用户搜索",
};

export default locale
